import React from 'react';
import { Link } from 'react-router-dom';
import { FiBarChart2 } from 'react-icons/fi';
import styles from './styles.module.scss';

export default function AnalyticsLink({ subjectId, set, subjectName, status }) {
    return (
        <Link
            className={styles.analyticsLink}
            to={`/dashboard/practice-mcq/analytics/${subjectId}/${set}${window.location.search}`}
            state={{ subjectName, testStatus: status }}
            title={`View analytics · ${subjectName} · Test ${set}`}
            aria-label={`View analytics for ${subjectName}, Test ${set}`}
        >
            <FiBarChart2 aria-hidden="true" />
        </Link>
    );
}
